/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { HttpException } from './HttpException';

/**
 * HTTP error for 302 redirects
 */
export class HttpRedirectException extends HttpException {
    public static Name: string = 'HttpRedirectException';
    public location: string;

    constructor(location: string) {
        super(302);
        this.location = location;
        this.name = HttpRedirectException.Name;
    }
}
